export interface OfferPricingFields {
  monthlyPrice?: number | null;
  annualPrice?: number | null;
  originalPrice?: number | null;
  savingsAmount?: number | null;
  discountPercentage?: number | null;
}

export interface OfferCharge {
  totalCost: number;
  discountedCost: number;
  discountedPercentage: number;
  saving: number;
}

export function buildOfferCharge(
  pricing: OfferPricingFields,
  isAnnual: boolean,
  seats = 1,
): OfferCharge {
  const perInterval = (isAnnual ? pricing.annualPrice : pricing.monthlyPrice) ?? 0;
  const charged = perInterval * seats;
  return {
    totalCost: charged,
    discountedCost: charged,
    discountedPercentage: isAnnual ? pricing.discountPercentage ?? 0 : 0,
    saving: isAnnual ? (pricing.savingsAmount ?? 0) * seats : 0,
  };
}
